import React from "react";
import { useParams } from "react-router-dom";
import Plasticos from "./Plasticos";
import Quimicos3 from "./Quimicos3";


function Lineas2() {
  let { division } = useParams();
  
if (division==="Químicos"){
  return (
    <div>
      <div className="w-100 relative">
        <img
          src="/pellets_banner.jpg"
          alt="banner-divisiones"
          className="w-[100%]"
        />
      </div>
      <div className="flex flex-col justify-center items-center w-[100%] ">
       <Quimicos3 />
      </div>
      
    </div>
  );
}else if (division==="Plásticos"){
  return(
    <div>
     <div className="w-100 relative">
        <img
          src="/banner_pellets-blanco.jpg"
          alt="banner-divisiones"
          className="w-[100%]"
        />
      </div>
      <div className="flex flex-col justify-center items-center w-[100%]">
       <Plasticos />
      </div>
    </div>
  )

}
 
}

export default Lineas2;
